import { FC, ReactNode } from 'react';

import { Button } from '@bonusly/design-system';
import { useIsBizyEnabledForUser } from '@bonusly/who-am-i';

import { dispatchBizyOpenEvent } from './hooks/use-bizy-open-listener';

export type BizyFeatureRequestButtonProps = {
	/** Passed to analytics and Bizy as page context (e.g. `points_activity_report`). */
	pageContext: string;
	/** Auto-sent starter message when the panel opens. */
	starterMessage: string;
	children: ReactNode;
};

/**
 * Opens the Bizy side panel in feature-request mode with the given page context and starter message.
 * Renders nothing when Bizy is disabled for the company.
 */
export const BizyFeatureRequestButton: FC<BizyFeatureRequestButtonProps> = ({ pageContext, starterMessage, children }) => {
	const isBizyEnabledForUser = useIsBizyEnabledForUser();
	if (!isBizyEnabledForUser) {
		return null;
	}

	return (
		<Button
			variant="link"
			size="sm"
			color="text.interactive"
			fontWeight="normal"
			onClick={() =>
				dispatchBizyOpenEvent({
					source: 'feature_request',
					pagePath: window.location.pathname,
					pageContext,
					starterMessage,
				})
			}
			_focusVisible={{ borderColor: 'border.focus', borderWidth: '2px' }}
		>
			{children}
		</Button>
	);
};
